import {os} from '../../../constants/osNames'

export const isDownloadStep = !os.isWindows && !os.isMacOs
